// extracted by mini-css-extract-plugin
export var active = "_2h-7";
export var backButton = "_2h-6";
export var clone = "_2h-c";
export var collapseBar = "_2h-h";
export var collapseMode = "_2h-j";
export var collapsed = "_2h-l";
export var dragHandle = "_2h-a";
export var dropdownIcon = "_2h-e";
export var expanding = "_2h-k";
export var hidden = "_2h-r";
export var iconContainer = "_2h-o";
export var iconSwapper = "_2h-q";
export var navItem = "_2h-4";
export var navItemIcon = "_2h-d";
export var navProfile = "_2h-5";
export var notificationCountBadge = "_2h-g";
export var notificationDot = "_2h-p";
export var optionsContainer = "_2h-f";
export var primaryNav = "_2h-0";
export var primaryTab = "_2h-m";
export var secondaryNav = "_2h-1";
export var selected = "_2h-n";
export var settingsNav = "_2h-2";
export var settingsNavItems = "_2h-3";
export var show = "_2h-b";
export var sideNav = "_2h-i";
export var teamItem = "_2h-8";
export var userProfileItem = "_2h-9";